// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoginWrapper_wrapper__12lcB","container":"LoginWrapper_container__R7fn6","section":"LoginWrapper_section__2_f6v","header":"LoginWrapper_header__367-B"};